exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#recommended-program .consent{padding-bottom:10px}#recommended-program #program-permissions{margin-top:0}", ""]);

